/* cart-upsell.js — "Complete your look" in cart drawer + cart page
   - one-tap add for single-variant products
   - upgrades the fallback collection to Shopify complementary recommendations when available */
(function () {
  "use strict";
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
  var pending = {};   // productId -> Promise<html>
  var resolved = {};  // productId -> html ("" = no recommendations)

  function fetchRecs(pid) {
    if (pending[pid]) return pending[pid];
    var url = root + "recommendations/products?product_id=" + encodeURIComponent(pid) +
      "&limit=10&intent=complementary&section_id=cart-upsell-recs";
    pending[pid] = fetch(url, { headers: { Accept: "text/html" } })
      .then(function (r) { return r.ok ? r.text() : ""; })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var wrap = doc.querySelector("[data-cu-cards]");
        var out = wrap && wrap.querySelector(".cu-card") ? wrap.innerHTML : "";
        resolved[pid] = out;
        return out;
      })
      .catch(function () { resolved[pid] = ""; return ""; });
    return pending[pid];
  }

  function esc(s) {
    var d = document.createElement("div");
    d.textContent = s || "";
    return d.innerHTML;
  }

  function apply(el, html) {
    if (!html || !el.isConnected) return;
    var limit = parseInt(el.dataset.limit, 10) || 6;
    var track = el.querySelector("[data-cu-track]");
    if (!track) {
      el.innerHTML = '<div class="cu__inner"><p class="cu__heading">' + esc(el.dataset.heading) +
        '</p><div class="cu__track" data-cu-track></div></div>';
      track = el.querySelector("[data-cu-track]");
    }
    track.innerHTML = html;
    var cards = track.querySelectorAll(".cu-card");
    for (var i = limit; i < cards.length; i++) cards[i].remove();
    track.scrollLeft = 0;
  }

  function enhance(el) {
    if (el.dataset.cuDone) return;
    el.dataset.cuDone = "1";
    if (el.dataset.mode !== "smart") return;
    var pid = el.dataset.productId;
    if (!pid) return;
    if (pid in resolved) { apply(el, resolved[pid]); return; } // instant, no flicker on drawer refresh
    fetchRecs(pid).then(function (html) { apply(el, html); });
  }

  function scan(scope) {
    (scope || document).querySelectorAll("[data-cart-upsell]").forEach(enhance);
  }

  // One-tap add
  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-cu-add]");
    if (!btn) return;
    e.preventDefault();
    if (btn.disabled) return;
    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = "Adding…";
    fetch(root + "cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: Number(btn.dataset.cuAdd), quantity: 1 })
    })
      .then(function (r) {
        if (r.ok) return r.json();
        return r.json().catch(function () { return {}; }).then(function (d) {
          throw new Error(d.description || "Unavailable");
        });
      })
      .then(function () {
        btn.textContent = "Added ✓";
        if (btn.closest("[data-cart-drawer]")) {
          document.dispatchEvent(new CustomEvent("cart:updated")); // drawer re-renders itself
        } else {
          window.location.reload(); // cart page: refresh totals + lines
        }
      })
      .catch(function () {
        btn.textContent = "Sold out";
        setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 1800);
      });
  });

  function init() {
    scan(document);
    var body = document.querySelector("[data-cart-drawer-body]");
    if (body && "MutationObserver" in window) {
      new MutationObserver(function () { scan(body); }).observe(body, { childList: true });
    }
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
